import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { LockOpenOutlined } from '@mui/icons-material';
import {
  Box,
  Fab,
  FormControl,
  InputLabel,
  Link,
  OutlinedInput,
  Slide,
  Typography
} from '@mui/material';

import {
  cardSx,
  contentSx,
  fieldSx,
  headerSx,
  roundButtonSx
} from '../../../../common/styles/forgotStyles';

const ForgotUn = () => {
  const [forgotu, setForgotu] = useState(true);
  const [sentu, setSentu] = useState(false);
  const [email, setEmail] = useState('');

  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const showSent = () => {
    setForgotu(false);
    setSentu(true);
  };

  return (
    <Slide
      direction="down"
      in
      timeout={300}
    >
      <Box>
        {forgotu && (
          <Box sx={cardSx}>
            <Box sx={headerSx}>
              <LockOpenOutlined />

              <Typography variant="h1">
                Forgot your Username?
              </Typography>
            </Box>

            <Box sx={contentSx}>
              <Typography variant="h6">
                Please enter email associated with account
              </Typography>

              <FormControl
                sx={fieldSx}
                variant="outlined"
              >
                <InputLabel htmlFor="email">
                  Email
                </InputLabel>

                <OutlinedInput
                  id="email"
                  label="Email"
                  name="email"
                  onChange={event => setEmail(event.target.value)}
                  type="email"
                  value={email}
                />
              </FormControl>

              <br />

              <Fab
                color="primary"
                disabled={!isEmailValid}
                onClick={showSent}
                size="medium"
                sx={roundButtonSx}
                variant="extended"
              >
                Request Username
              </Fab>

              <Typography
                sx={{
                  color: '#939393',
                  fontSize: 10,
                  mt: 1
                }}
              >
                Did you remember your username?{' '}

                <Link
                  component={RouterLink}
                  to="/sign-in"
                >
                  Try Logging in
                </Link>
              </Typography>
            </Box>
          </Box>
        )}

        {sentu && (
          <Box sx={cardSx}>
            <Box sx={headerSx}>
              <LockOpenOutlined />

              <Typography variant="h1">
                Forgot your Username?
              </Typography>
            </Box>

            <Box sx={contentSx}>
              <Typography>
                To ensure your security, a confirmation email has been sent to
                the registered email address.
              </Typography>

              <br />

              <Fab
                color="primary"
                component={RouterLink}
                size="medium"
                sx={roundButtonSx}
                to="/sign-in"
                variant="extended"
              >
                Go Back
              </Fab>
            </Box>
          </Box>
        )}
      </Box>
    </Slide>
  );
};

export default ForgotUn;